import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `ParagraphText` or `UtilityText` from `genesis-core` instead
 */

export const BodyTwoSecondary = forwardRef<HTMLElement, TextProps>(
  (props, ref) => (
    <Text
      as="p"
      color="onSurface.text.subdued"
      typography="bodyTwoSecondary"
      ref={ref}
      {...props}
    />
  )
);

BodyTwoSecondary.displayName = 'BodyTwoSecondary';
